<template>
  <!-- TODO: generalize `Group` and `ExcludedGroup` components -->
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      item-key="id"
      hide-default-footer
      class="shadow c-data-table--alternate overflow-hidden"
    >
      <template #top>
        <div class="pl-4 py-2">
          <v-row row wrap justify="space-between" align="center">
            <v-col lg="6">
              <div class="body-1 navy--text text--darken-1 font-weight-medium">
                Vyloučené okruhy zájmů
              </div>
            </v-col>
            <v-col>
              <div class="d-flex justify-end text-xs-right mr-4">
                <v-btn @click="modalOpened = true" text small color="navy">
                  <v-icon left>
                    mdi-plus-circle-outline
                  </v-icon>
                  Vyloučit okruh zájmu
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </div>
      </template>

      <template #item.name="{ item }">
        <div class="py-6" v-text="item.name" />
      </template>

      <template #item.audience_size="{ item }">
        {{
          item.audienceSizeLowerBound
            ? item.audienceSizeLowerBound.toLocaleString()
            : ""
        }}
      </template>

      <template #item.path="{ item }">
        {{ item.path ? item.path.join(" > ") : "" }}
      </template>

      <template #item.actions="{ item }">
        <v-btn @click="itemsRemove(item)" text small color="primary">
          <v-icon left>
            mdi-minus-circle-outline
          </v-icon>
          Smazat
        </v-btn>
      </template>

      <template #no-data>
        <div class="pt-14">
          <icon-audience-excluded-group
            class="navy--text text--lighten-2 mb-12"
            :style="{
              '--diagram-label-color': 'var(--v-navy-lighten1)',
            }"
          />
          <div class="pb-9 primary--text">
            <div class="headline mb-2 font-weight-medium">
              Vylučte okruh zájmu
            </div>
            <div class="mb-8 noData__text">
              Pro ještě lepší zacílení vylučte lidi, kteří nekorespondují s
              předešlým krokem.
            </div>
            <div>
              <v-btn @click="modalOpened = true" color="primary" class="c-btn">
                Přidat okruh zájmu
                <v-icon right>mdi-plus</v-icon>
              </v-btn>
            </div>
          </div>
        </div>
      </template>
    </v-data-table>

    <targeting-interests-modal :opened.sync="modalOpened" @save="itemsAppend" />
  </div>
</template>

<script>
import TargetingInterestsModal from "@/components/ui/modals/TargetingInterestsModal.vue"
import IconAudienceExcludedGroup from "@/components/icon/audience/ExcludedGroup.vue"

const headers = [
  {
    text: "Zájem",
    align: "start",
    value: "name",
    sortable: false,
  },
  { text: "Velikost publika", value: "audience_size", sortable: false },
  { text: "Cesta", value: "path", sortable: false },
  { text: "", value: "actions", sortable: false },
]

export default {
  name: "ExcludedInterestsGroup",
  components: {
    TargetingInterestsModal,
    IconAudienceExcludedGroup,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      headers,
      modalOpened: false,
    }
  },
  methods: {
    itemsAppend(items) {
      this.$emit("itemsAppend", items)
    },
    itemsRemove(items) {
      this.$emit("itemsRemove", items)
    },
  },
}
</script>

<style scoped>
.noData__text {
  max-width: 410px;
  margin-left: auto;
  margin-right: auto;
  font-size: 14px;
}
</style>
